import React, { useEffect, useState } from "react";
import { getAllUseCaseVideos } from "../../api/api";
import VideoPlayer from "../../Components/VideoPlayer/VideoPlayer";

const LectureAnalysisVideo = () => {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    async function fetchVideo() {
      try {
        const data = await getAllUseCaseVideos();
        // //console.log(data?.data?.data);
        const video = data?.data?.data?.find(
          (v) => v._id === "686bb314ab7d4a58aa2e9637"
        );
        // //console.log(video);
        if (video && video.video_path) {
          setVideoUrl(video.video_path);
        }
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    }
    fetchVideo();
  }, []);
  return (
    <div>
      <nav className="navbar navbar-dark bg-dark px-3">
        <span className="navbar-brand">Lecture analysis Videos</span>
      </nav>

      <VideoPlayer
        videoUrl={"https://visionemptrack.greymatterz.com/" + videoUrl}
        title="Lecture Analysis Video"
        description="Lecture analysis video for the company"
      />
    </div>
  );
};

export default LectureAnalysisVideo;
